export const commonWall = `\
-- common bond
-- running bond with a header course every 6th row

S >>
H
S >>
S
S >>
S
`
